import { createAsyncActionTypes } from 'src/core/util/async-action-type-creator';

export const GET_COMPANY = createAsyncActionTypes('GET_COMPANY');
export const UPDATE_COMPANY = createAsyncActionTypes('UPDATE_COMPANY');
export const GET_COMPANY_ACCESS = createAsyncActionTypes('GET_COMPANY_ACCESS');
export const GET_COMPANY_VENUES = createAsyncActionTypes('GET_COMPANY_VENUES');
export const RESET_COMPANY_DETAIL = 'RESET_COMPANY_DETAIL';
